import { css, cx } from 'emotion';

import {
	headingLarge,
	headingXLarge,
	headingSmallLight,
	mobileMaxWidthBreakpoint,
	desktopMaxWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
	textBlock,
	lightGrey,
	orange,
	museo500,
	contentSection,
	label,
} from 'inside-out/global-styles';

import ScreenerBG from './bg.svg';

export const wrapperStyle = css({
	background: `transparent url(${ScreenerBG}) no-repeat bottom right`,
	paddingBottom: '247px',
});

// Same as assessment for remember prompt
export const wrapperResultsStyle = css({
	[`@media(max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		paddingBottom: '124px',
	},
});

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	padding: '0 20px',
	position: 'relative',
	overflowX: 'hidden',
});

export const progressStyle = progressPercent =>
	css({
		height: '8px',
		background: lightGrey,
		position: 'relative',
		'&:after': {
			transition: 'width 0.5s ease-in',
			position: 'absolute',
			top: '0',
			left: '0',
			height: '100%',
			width: `${progressPercent}%`,
			content: '" "',
			display: 'block',
			background: orange,
		},
	});

export const scoreStyle = cx(
	label,
	css({
		margin: '0 0 24px 0',
	})
);

export const titleStyle = cx(
	headingXLarge,
	css({
		minHeight: '114px',
		margin: '0 0 24px 0',
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			minHeight: '60px',
		},
	})
);

export const bodyTextStyle = cx(
	textBlock,
	css({
		minHeight: '100px',
		maxWidth: '900px',
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '14px',
		},
	})
);

export const resultTitleStyle = color =>
	cx(
		headingLarge,
		css({
			margin: '0 0 24px 0',
			'& p': {
				margin: 0,
			},
			'& strong': {
				color: color,
				fontStyle: 'normal',
			},
		})
	);

export const answerStyle = index =>
	css({
		...museo500,
		margin: '0 1.5px',
		width: '100%',
		height: '134px',
		color: '#fff',
		fontSize: '22px',
		lineHeight: '27px',
		fontWeight: 'normal',
		outline: 'none',
		boxSizing: 'border-box',
		cursor: 'pointer',
		border: '4px solid transparent',
		background: `hsl(180, ${34.8 + index * 2.5}%, ${31.4 + index * 5}%)`,
		// '&:hover': {
		// 	borderBottom: `4px solid ${orange}`,
		// },
		'&:active': {
			background: orange,
		},
		'&:first-child': {
			borderRadius: '6px 0 0 6px',
		},
		'&:last-child': {
			borderRadius: '0 6px 6px 0',
		},
	});

export const answerActiveStyle = cx(
	answerStyle,
	css({
		background: orange,
	})
);

export const answersWrapStyle = css({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	alignItems: 'center',
	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		flexDirection: 'column',
		'& button': {
			maxWidth: 'initial',
			height: '50px',
			margin: '1.5px 0',
			fontSize: '14px',
			lineHeight: '17px',
			'&:first-child': {
				borderRadius: '6px 6px 0 0',
			},
			'&:last-child': {
				borderRadius: '0 0 6px 6px',
			},
		},
	},
});

export const additionalStyleWrapper = cx(
	contentSection(),
	css({
		marginTop: '60px',
	})
);

export const additionalStyle = css({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	alignItems: 'center',

	'& > div': {
		width: '450px',
	},

	'& h2': cx(
		headingSmallLight,
		css({
			marginBottom: '16px',
		})
	),

	'& p': cx(
		textBlock,
		css({
			margin: '0 0 24px 0',
		})
	),

	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		flexDirection: 'column',
		'& > div': {
			width: '100%',
			'&:last-child': {
				marginTop: '60px',
			},
		},
	},
});

export const compressedStyle = css({
	[`& button`]: {
		height: '60px',
		fontSize: '18px',
		lineHeight: '22px',
	},
});

export const boolStyle = css({
	justifyContent: 'start',
	[`& button`]: {
		width: '150px',
		height: '60px',
	},
});

export const backButtonWrapperStyle = css({
	paddingTop: '20px'
});

export const backButtonInnerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	margin: '0 auto',
	padding: '0 20px',
	overflowX: 'hidden',
});

export const backButtonStyle = css({
	display: 'flex',
	alignItems: 'center',
	color: '#8A8B8C',
	fontSize: '14px',
	lineHeight: '17px',
	fontWeight: 'bold',
	userSelect: 'none',
	cursor: 'pointer',
	'& svg': {
		marginRight: '10px',
	}
});


// WEBPACK FOOTER //
// ./src/components/shared/screener/styles.js